export let Cadence;
(function (Cadence) {
  Cadence["Month"] = "MONTH";
  Cadence["Quarter"] = "QUARTER";
})(Cadence || (Cadence = {}));